import Vue from 'vue'
import Vuex from 'vuex'
import authentication from './authentication'
import users from './users'
import app from './app'
import sessions from './sessions'
import whitelists from './whitelists'
import fleets from './fleets'
import reports from './reports'
import places from './places'
import campaigns from './campaigns'
import enforcement from './enforcement'
import zones from './zones'
import booking from './booking'
import vehicleGroups from './vehicle-groups'
import disputes from './disputes'

Vue.use(Vuex)

/* If you don't know about Vuex, please refer to https://vuex.vuejs.org/ */

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    authentication,
    users,
    app,
    sessions,
    whitelists,
    fleets,
    reports,
    places,
    campaigns,
    enforcement,
    zones,
    booking,
    vehicleGroups,
    disputes
  }
})
